<template>
  <div
    class="main-totem"
    v-if="enterprise"
    :style="{ 
      '--background-color': bgColor ? `#${bgColor}`: 'transparent',
      '--background': bgColor ? 'auto': 'none',
    }"
  >
    <main-content
      :enterprise="enterprise"
    />
    <main-menu />
    <meteo-language
      v-if="!isTotemAccessibility"
    />
    <sidebar />
    <accessibility
      v-if="!isTotemAccessibility"
    />
    <meteo-language
      v-else
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '@/services/api'
import utils from '@/services/utils'
import Accessibility from './Accessibility'
import Sidebar from './sidebar/Index'
import MainMenu from './mainMenu/Index'
import MeteoLanguage from './meteoLanguage/Index'
import MainContent from './Content'
export default {
  components: {
    Sidebar,
    MainMenu,
    Accessibility,
    MeteoLanguage,
    MainContent
  },
  data () {
    return {
      bgColor: null,
      enterprise: null
    }
  },
  computed: {
    ...mapState('app',['isTotemAccessibility']),
    envValue () {
      return process.env.VUE_APP_ENV
    }
  },
  mounted () {
    this.bgColor = this.$route.query.color
    api.getItem('enterprises', false, utils.getDomain()).then(response => {
      this.enterprise = response
      if (response.TimeZone) this.$store.state.app.TimeZone = response.TimeZone

      this.$store.state.app.totemMeteoID = response.MeteoID
      this.$store.state.app.Languages = response.Languages.split(',')
      this.$store.state.app.DefaultLocale = response.DefaultLocale ? response.DefaultLocale : 'es'
      this.$store.state.app.authType = response.AuthType && response.AuthType.length > 0 ? response.AuthType : 'none'

      if (!this.bgColor || this.bgColor.length === 0) {
        this.bgColor = this.enterprise.BGColor.replace('#', '')
      }
    })
  }
}
</script>

<style>
  body {
    background-color: transparent;
    background: none;
    /* background-color: red !important; */
  }
  #app {
    background-color: transparent !important;
    background: none;
  }
  .theme--light.v-application {
    background-color: transparent !important;
    background: none;
  }
  table {
    border: 0px;
    border-spacing: 0px;
  }
  html {    
    background-color: transparent;
  }
  .label {
    color: #FFFFFF80;
    font-size: 12px;
    font-weight: 700;
  }
  .main-totem {
    width: calc(100vw);
    height: calc(100vh);
    background-color: var(--background-color);
  }
</style>
